/* eslint-disable react/jsx-key */
import { BoxWrapper, Modal, Button } from 'components/Base';
import React, { useState, useEffect } from 'react';
import { setupMarketCommentaries } from '../utils';
import { makeStyles } from '@material-ui/core';

interface Props {
  provider: any;
}

const useStyles = makeStyles({
  content: {
    '& p': {
      margin: 0
    }
  }
});

const MarketCommentaries = ({ provider }: Props) => {
  const classes = useStyles();
  const [isOpen, setIsopen] = useState(false);
  const [marketCommentaries, setMarketCommentaries] = useState([]);
  const [marketCmmentary, setmarketCmmentary] = useState() as any;

  useEffect(() => {
    setMarketCommentaries(
      setupMarketCommentaries(provider.market_commentaries).filter(
        (commentary: any) => !!commentary.content
      )
    );
  }, []);

  return (
    <BoxWrapper title="Market Commentary" style={{ flex: 1 }}>
      <div
        style={{
          padding: '1rem',
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '1rem'
        }}
      >
        {marketCommentaries.map((market_commentarie: any) => {
          return (
            <>
              <Button
                type="button"
                onClick={() => {
                  setmarketCmmentary(market_commentarie);
                  setIsopen(true);
                }}
              >
                {market_commentarie.name}
              </Button>
            </>
          );
        })}
      </div>
      {marketCmmentary && (
        <Modal isOpen={isOpen} closeModalFunc={() => setIsopen(false)}>
          <BoxWrapper
            title={marketCmmentary.name}
            closeModal={() => setIsopen(false)}
          >
            <div
              style={{
                padding: '1rem',
                minWidth: '550px',
                overflow: 'auto',
                maxWidth: '90vw',
                maxHeight: '80vh'
              }}
              className={classes.content}
              dangerouslySetInnerHTML={{
                __html: marketCmmentary.content
              }}
            ></div>
          </BoxWrapper>
        </Modal>
      )}
    </BoxWrapper>
  );
};

export default MarketCommentaries;
